import Vue from 'vue';
import Ionic from '@ionic/vue';
import App from './App.vue';

// ----------------------------- o

import router from './router/index';
import store from './store/index';

// ----------------------------- o

import Transitions from 'vue2-transitions'
Vue.use(Transitions)

// ----------------------------- o

import VueMask from 'v-mask'
Vue.use(VueMask);

// ----------------------------- o

import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

// ----------------------------- o

Vue.config.productionTip = false;
Vue.use(Ionic);

// ----------------------------- o

import "@/assets/sass/app.scss";

// ----------------------------- o

const app = new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')

// access Vue instance by
// adding $app to store object
store.$app = app;